// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"440":"d0df3cf88faba073","581":"a77aa257f2daab7f","768":"d0a864a67a970269"}[chunkId] + ".js";
};